import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAnalytics } from '../services/analytics';
import { isAnalyticsConnectedSelector } from '../redux/reducers/domain/analytics';

export const useClickStreamPageView = () => {
  const { pathname } = useLocation();
  const isAnalyticsConnected = useSelector(isAnalyticsConnectedSelector);
  const analytics = getAnalytics();
  useEffect(() => {
    if (isAnalyticsConnected) {
      analytics?.pageview();
    }
  }, [pathname, analytics, isAnalyticsConnected]);
};
